import { CookieConsentCookieNames, CookieHandler } from "../global/cookieconsent/cookieHandler";
import { DebugCookieEntry } from "./debugCookieEntry";
import { writeDebugMenuEntry } from "./debugMenuFunctions";
import { EventVerteiler } from "../global/eventVerteiler";
export const VIEWERFEATURE = {
    USE_DROPPABLE_FROM_STOFF: true,
    SHOW_ALL_COLORS: false,
    LOG_HIT_PARTS_in_CONSOLE: false,
    DELETE_CACHE: () => $.get("/konfigurator_php/debug/deleteCachedContent.php", r => alert(r)),
    WRITE_LEGACYFONTS_FOR_CURRENT_LOGIN: null,
    OWAYO_NOCACHING: new DebugCookieEntry(CookieHandler.NOCACHING_COOKIENAME, "Backend Ergebnisse nicht cachen"),
    KONFI_DEVELOPEMENT_MODE: new DebugCookieEntry(CookieHandler.DEVMODE_COOKIENAME, "Konfi Developement Mode"),
    SHOW_SHADEREDITOR: new DebugCookieEntry(CookieHandler.SHADEREDITOR_COOKIENAME, "km shader editor Button"),
    EDIT_MATERIALS: false,
    PATTERN_WITHOUT_REPEAT: false,
    SPEICHERE_ENTWURF_FUER_KUNDENKONFI: null,
    DELETE_ALL_COOKIES_SET_NOCACHING: function () {
        document.cookie.split(";").forEach(function (c) {
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        VIEWERFEATURE.OWAYO_NOCACHING.toggle();
        alert("all cookies deleted, OWAYO_NOCACHING set");
    },
    SET_COOKIE_CONSENTVERSION_2_COOKIE: () => CookieHandler.createCookie(CookieConsentCookieNames.VERSION, "2.0", 365),
    BUILDALLSHADERS: () => EventVerteiler.broadcast("recreateAllShadersEvent"),
    SHADER_EDITOR: null,
    EVENTLOG: {
        displayString: function () {
            return "";
            // return "<li><a href='#' onclick='VIEWERFEATURE.EVENTLOG.display();'>eventlog anzeigen</a></li>"
            //     +   "<li><a href='#' onclick='VIEWERFEATURE.EVENTLOG.clear();'>eventlog löschen</a></li>";
        },
        isOn: true,
        log: [],
        display: function () {
            console.log(VIEWERFEATURE.EVENTLOG.log.join("\n"));
        },
        clear: function () {
            VIEWERFEATURE.EVENTLOG.log = [];
            alert("gelöscht");
        },
        compressLog: function (eventLogWithoutHints) {
            const sortedArray = [];
            for (let i = 0, lenI = eventLogWithoutHints.length; i < lenI; i++) {
                if (i === 0 || sortedArray[sortedArray.length - 1].message !== VIEWERFEATURE.EVENTLOG.log[i]) {
                    sortedArray.push({ message: VIEWERFEATURE.EVENTLOG.log[i], count: 1 });
                }
                else {
                    sortedArray[sortedArray.length - 1].count += 1;
                }
            }
            return sortedArray;
        },
        printHTML: function () {
            const eventLogWithoutHints = VIEWERFEATURE.EVENTLOG.log.filter(function (message) {
                return message !== "displayHintEvent";
            });
            return this.compressLog(eventLogWithoutHints)
                .reduce(function (carry, logEntry) {
                carry += "<li>" + logEntry.message;
                if (logEntry.count > 1) {
                    carry += " (" + logEntry.count + ")";
                }
                carry += "</li>";
                return carry;
            }, "<ul>")
                + "</ul>";
        }
    },
    // RENDER_STEREO: {
    //     optionInMenuDisabled: true,
    //     isOn: false,
    //     displayString: function () {
    //         return (this.optionInMenuDisabled ? '' :
    //                 writeDebugMenuEntry('VIEWERFEATURE.RENDER_STEREO.toggle();',
    //                     "3d Brillen Shader ist: " + "<span id='debug_RENDER_STEREO' class= 'redFont'>aus</span>")
    //         );
    //     },
    //     toggle: function () {
    //         VIEWERFEATURE.RENDER_STEREO.isOn = !VIEWERFEATURE.RENDER_STEREO.isOn;
    //         const spanstyle = "style='color:" + (this.isOn ? "green'>an" : "red'");
    //         const spanText = this.isOn ? "an" : "aus";
    //         $("#debug_RENDER_STEREO").replaceWith("<span id='#debug_RENDER_STEREO' " + spanstyle + ">" + spanText + "</span>");
    //         if (this.isOn && typeof (globalsObject.owayoJSViewer.effect) === "undefined") {
    //             globalsObject.owayoJSViewer.effect = new THREE.AnaglyphEffect(globalsObject.owayoJSViewer.renderer);
    //             globalsObject.owayoJSViewer.effect.setSize(globalsObject.owayoJSViewer.dimensions.viewer.width, globalsObject.owayoJSViewer.dimensions.viewer.height);
    //         }
    //         if (this.isOn) {
    //             this.insertPlanes();
    //         } else {
    //             this.removePlanes();
    //         }
    //     },
    //     insertPlanes: function () {
    //         let selectionPlane;
    //             const texture = THREE.ImageUtils.loadTexture("img/layout/owayo_logo_power2.png"),
    //             texture2 = THREE.ImageUtils.loadTexture("img/layout/owayo_logo_power2.png");
    //
    //         texture.wrapS = THREE.RepeatWrapping;
    //         texture.wrapT = THREE.RepeatWrapping;
    //         texture2.wrapS = THREE.RepeatWrapping;
    //         texture2.wrapT = THREE.RepeatWrapping;
    //         texture.repeat.set(16, 24);
    //         texture2.repeat.set(8, 16);
    //         selectionPlane = new THREE.Mesh(
    //             new THREE.PlaneBufferGeometry(globalsObject.owayoJSViewer.dimensions.model.x * 5, globalsObject.owayoJSViewer.dimensions.model.y * 5),
    //             new THREE.MeshLambertMaterial({map: texture, side: THREE.DoubleSide}));
    //
    //
    //         selectionPlane.position.set(0, -globalsObject.owayoJSViewer.dimensions.model.y / 2, -5);
    //         selectionPlane.rotation.set(-Math.PI / 2, 0, 0);
    //         globalsObject.owayoJSViewer.scene.add(selectionPlane);
    //         selectionPlane = new THREE.Mesh(
    //             new THREE.PlaneBufferGeometry(globalsObject.owayoJSViewer.dimensions.model.x * 2, globalsObject.owayoJSViewer.dimensions.model.y * 5),
    //             new THREE.MeshLambertMaterial({map: texture2, side: THREE.DoubleSide}));
    //         selectionPlane.position.set(0, 0, -15);
    //
    //         globalsObject.owayoJSViewer.scene.add(selectionPlane);
    //     },
    //     removePlanes: function () {
    //         let i;
    //         for (i = globalsObject.owayoJSViewer.scene.children.length - 1; i > -1; i--) {
    //             if (typeof (globalsObject.owayoJSViewer.scene.children[i].geometry) !== "undefined" &&
    //
    //                 globalsObject.owayoJSViewer.scene.children[i].geometry.type === "PlaneBufferGeometry") {
    //
    //                 globalsObject.owayoJSViewer.scene.children[i].material.map.dispose();
    //                 globalsObject.owayoJSViewer.scene.remove(globalsObject.owayoJSViewer.scene.children[i]);
    //             }
    //         }
    //     }
    // },
    LOCALIZER_MISSINGENTRIES: {
        errors: [],
        displayString: function () {
            return writeDebugMenuEntry('VIEWERFEATURE.LOCALIZER_MISSINGENTRIES.showLog();', "Fehlende Übersetzungen anzeigen");
        },
        showLog: function () {
            //
            // if (typeof (untranslatedFromTemplateCompiler) !== "undefined") {
            //     alert("UntranslatedFromTemplateCompiler\n" + untranslatedFromTemplateCompiler.join("\n"));
            // }
            // alert(VIEWERFEATURE.LOCALIZER_MISSINGENTRIES.errors.join("\n"));
        }
    },
    LOG_COLOROBJECT: null,
    SHOW_EMPTY_HIGHLIGHTS: null
};
// noinspection JSUnusedGlobalSymbols
if (typeof (window) !== "undefined") {
    window.VIEWERFEATURE = VIEWERFEATURE;
}
//# sourceMappingURL=debugMenu.js.map